export { Shirt as default } from './Shirt';
